import {
	SET_CURRENT_CLIENT_ID,
	FETCH_ALL_CLIENTS,
	SET_CLIENT,
	UPDATE_CLIENT,
	SET_DOMAIN,
	DELETE_DOMAIN,
} from '../actions/actionTypes';
import { arrToObj } from '../util';

const preState = {
	clients: {},
	currentClient: {},
};

const clientReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, clients, client, clientID, domain, domainIDClientID } = action;
	if (client && client.domains) client.domains = arrToObj(client.domains);

	switch (type) {
		case FETCH_ALL_CLIENTS:
			stateDup.clients = { ...stateDup.clients, ...arrToObj(clients) };
			return stateDup;
		case SET_CLIENT:
			stateDup.clients[client.id] = client;
			stateDup.currentClient = { ...client };
			return stateDup;
		case UPDATE_CLIENT:
			const newClient = { ...stateDup.clients[client.id], ...client };
			stateDup.clients[client.id] = newClient;
			stateDup.currentClient = newClient;
			return stateDup;
		case SET_DOMAIN:
			stateDup.clients[domain.client_id].domains[domain.id] = domain;
			if (stateDup.currentClient.id === domain.client_id) {
				stateDup.currentClient.domains[domain.id] = domain;
			}
			return stateDup;
		case DELETE_DOMAIN:
			const { domainID, clientID: domainClientID } = domainIDClientID;
			delete stateDup.clients[domainClientID].domains[domainID];
			if (stateDup.currentClient.id === domainClientID) {
				delete stateDup.currentClient.domains[domainID];
			}
			return stateDup;
		case SET_CURRENT_CLIENT_ID:
			if (!stateDup.currentClient || clientID !== stateDup.currentClient.id) {
				stateDup.currentClient = stateDup.clients[clientID] || {};
			}
			return stateDup;
		default:
			return state;
	}
};

export default clientReducer;
